import { render, staticRenderFns } from "./AllocationChannelSingle.vue?vue&type=template&id=d1f70c82&scoped=true&"
import script from "./AllocationChannelSingle.vue?vue&type=script&lang=js&"
export * from "./AllocationChannelSingle.vue?vue&type=script&lang=js&"
import style0 from "./AllocationChannelSingle.vue?vue&type=style&index=0&id=d1f70c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f70c82",
  null
  
)

export default component.exports